import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SiteNotice from '../components/SiteNotice';
import BetweenSales from './BetweenSales';

/**
 * THE HOME ROUTE — always the landing page (BetweenSales). No swap to the sale list.
 *
 * The landing page leads with the open sales when there are any (isSaleOpen, the same definition
 * the sale list uses) and with the upcoming slate when there are none. The full sale list lives at
 * /browse (PublicAuctionList), and /browse?preview=true is still the operator's view of upcoming sales.
 *
 *   /?between=1   previews the no-sale layout at any time, even while a sale is live.
 *
 * History: until 1 Nov 2026 this file swapped between PublicAuctionList and BetweenSales, and held the
 * Schrodinger two-door featured-event landing (config/featuredEvent.ts, pages/TwoDoorLanding.tsx —
 * both left in place, unused; it was switched off on 17 Sep 2026).
 */
const Home: React.FC = () => {
  const [params] = useSearchParams();
  return <><SiteNotice /><BetweenSales previewNoSale={params.get('between') === '1'} /></>;
};

export default Home;
